import React, { Component } from 'react';

import { Link } from '~/lib/react-router-dom';

import ModeEditTwoToneIcon from '@mui/icons-material/ModeEditTwoTone';
import { IconButton } from '@mui/material';

import { LIST_VISIBILITY } from '../../../consts/schedule';
import { types } from '../../../consts/types';
import { scheduleForType } from '../../../utils/scheduleForType';

import Visibility from './Visibility';

type Props = {
  offer: {
    result: App.Offer;
  };
  schedules: App.Offer['brand_schedules'];
};

export default class SchedulePane extends Component<Props> {
  formatDate = (date_in: string) => {
    const date = new Date(date_in);
    return date.toDateString();
  };
  render() {
    const { offer, schedules } = this.props;
    const offerId = offer.result.id_salesforce_external;

    return (
      <span>
        <h1 className="page-header">
          Schedule
          <Link to={`/edit-offers/${offerId}/schedules`}>
            <IconButton aria-label="Edit">
              <ModeEditTwoToneIcon fontSize="large" />
            </IconButton>
          </Link>
        </h1>
        <div className="panel-section">
          <div className="schedule-summary">
            {types.map((type, index) => {
              return (
                <div key={`${index}-${type.code}`}>
                  <span className="h6 text-uppercase text-muted">{type.name}</span>
                  <span>
                    <div className="date">
                      {scheduleForType(schedules, type.code, 'start') ? (
                        <span className="date-labels">
                          <div className="date-start">
                            {this.formatDate(scheduleForType(schedules, type.code, 'start'))}
                          </div>
                          <div className="date-arrow">&#8594;</div>
                          <div className="date-end">
                            {this.formatDate(scheduleForType(schedules, type.code, 'end'))}
                          </div>
                        </span>
                      ) : (
                        <div className="empty">No Schedule Set</div>
                      )}
                    </div>
                  </span>
                </div>
              );
            })}
          </div>
          <Visibility offerId={offerId} schedules={schedules} type={LIST_VISIBILITY} />
        </div>
      </span>
    );
  }
}
